exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb-bjar{min-width:1000px!important}.table thead th{min-width:200px!important}#ptable tbody td p{margin-bottom:0!important}", ""]);

// exports
